import * as Sentry from "@sentry/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { WorkspaceUserInviteBody } from "@app/common/account/api";
import apiClient from "@app/common/api/apiClient";
import useAuth from "@app/common/auth/useAuth";

interface PostWorkspaceInvitesBody {
  workspaceId: string;
  invites: WorkspaceUserInviteBody[];
}

const useInviteToWorkspace = () => {
  const queryClient = useQueryClient();
  const { fetchAndSetUser } = useAuth();

  return useMutation({
    mutationFn: ({ workspaceId, invites }: PostWorkspaceInvitesBody) =>
      apiClient.workspace.inviteWorkspaceUsers(workspaceId, invites),
    onSettled: (_response, error, body) => {
      // refetch the user/billing account
      fetchAndSetUser();
      queryClient.invalidateQueries({ queryKey: ["billing"] });
      queryClient.invalidateQueries({
        queryKey: ["workspace", body.workspaceId],
      });

      if (error) {
        Sentry.captureException(error);
      }
    },
  });
};

export default useInviteToWorkspace;
